import { render } from "./ThankYouPage.vue?vue&type=template&id=237efd1d&scoped=true"
import script from "./ThankYouPage.vue?vue&type=script&lang=ts"
export * from "./ThankYouPage.vue?vue&type=script&lang=ts"

import "./ThankYouPage.vue?vue&type=style&index=0&id=237efd1d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-237efd1d"

export default script